/**
 * @generated SignedSource<<d5a7c4ec8d60a655e5d886623ded1c48>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type number_issueFieldNumberReadviewFull_NumberReadView$data = {
  readonly number: number | null | undefined;
  readonly " $fragmentType": "number_issueFieldNumberReadviewFull_NumberReadView";
};
export type number_issueFieldNumberReadviewFull_NumberReadView$key = {
  readonly " $data"?: number_issueFieldNumberReadviewFull_NumberReadView$data;
  readonly " $fragmentSpreads": FragmentRefs<"number_issueFieldNumberReadviewFull_NumberReadView">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "number_issueFieldNumberReadviewFull_NumberReadView",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "number"
    }
  ],
  "type": "JiraNumberField"
};

(node as any).hash = "f5619aebd026a31af25c138d6e347f21";

export default node;
